interface BlingLogoSvgProps {
  size?: number;
  className?: string;
}

export const BlinqLogoSvg = ({ size = 60, className }: BlingLogoSvgProps) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 248 248"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_5335_8390)">
      <rect x="0.000305176" width="248" height="248" fill="#F45A57" />
      <rect x="81.8408" width="8.23437" height="248" fill="white" />
      <path
        d="M162.005 77.7438C162.005 98.7435 144.981 115.767 123.981 115.767C102.982 115.767 85.958 98.7435 85.958 77.7438C85.958 56.744 102.982 39.7203 123.981 39.7203C144.981 39.7203 162.005 56.744 162.005 77.7438Z"
        stroke="white"
        strokeWidth="8.23437"
      />
      <path
        d="M162.005 170.256C162.005 191.256 144.981 208.279 123.981 208.279C102.982 208.279 85.958 191.256 85.958 170.256C85.958 149.256 102.982 132.232 123.981 132.232C144.981 132.232 162.005 149.256 162.005 170.256Z"
        stroke="white"
        strokeWidth="8.23437"
      />
    </g>
    <defs>
      <clipPath id="clip0_5335_8390">
        <rect width="248" height="248" rx="61.5194" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
